// utils/secureImageLoader.js
export const secureImageLoader = async (axios, folder, filename) => {
  try {
    // Normalize to just the filename; server expects container-relative path `${folder}/${filename}`
    const cleanFilename = String(filename)
      .replace(/^https?:\/\/[^/]+\/vault-images\/[^/]+\//i, '')
      .replace(/^\/+/, '')
      .split('?')[0]
      .split('#')[0];

    // 1) Ask API for a temporary SAS URL
    const encodedName = encodeURIComponent(cleanFilename);
    const sasRes = await axios.get(`/sas/${folder}/${encodedName}`);
    const sasUrl = sasRes?.data?.url;
    if (!sasUrl) throw new Error('Missing SAS URL in response');

    // 2) Fetch the actual image bytes with the SAS URL
    const blobRes = await axios.get(sasUrl, { responseType: 'blob' });
    return blobRes.data; // Blob
  } catch (err) {
    const status = err?.response?.status || 'Unknown';
    console.error(`[SecureImage] Blob fetch failed → folder: ${folder}, filename: ${filename}, status: ${status}`);
    return null;
  }
};
